import { ProfileMenu } from '~widgets/profile-menu';

import { ScreenHeader, ScreenHeaderProps } from '~shared/ui/screen';

export const PartnerApplicationMenuHeader = (props: ScreenHeaderProps) => {
  return (
    <ScreenHeader {...props} rightSlot={<ProfileMenu />} logoAlign="left" />
  );
};
